import { Text, XStack } from 'tamagui';
import { useThemeColors, Icon } from '@kiips/ui';
import { useItineraryStore } from '../../store/itinerary-store';

/**
 * Shared offline-state pill rendered by both SyncDot and SyncFreshnessPill
 * when `useIsOnline()` returns false. Keeps the two indicators in lockstep
 * — copy, icon, color, and queued-count formatting all change here.
 */
export function OfflineChip() {
  const theme = useThemeColors();
  const pendingCount = useItineraryStore(
    (s) => Object.keys(s.dirtyTrips).length + s.pendingDeletes.length,
  );
  // Colour the chip entirely from `theme.*` (JS): the `Icon` resolves its
  // colour through useThemeColors() (JS) and lags a CSS `$overlayCardAction`
  // fill on web hydration, so drive the fill + text from the same system.
  return (
    <XStack
      alignItems="center"
      gap={6}
      paddingHorizontal={10}
      paddingVertical={5}
      backgroundColor={theme.overlayCardAction}
      borderRadius={14}
    >
      <Icon name="cloud-off" size={14} color={theme.textOnSurface} />
      <Text fontSize={12} color={theme.textOnSurface} fontWeight="600">
        {pendingCount > 0 ? `Offline · ${pendingCount} queued` : 'Offline'}
      </Text>
    </XStack>
  );
}
